const SaleReturnDataValidation = (invoiceData) => {
    let isValid = true;
    let Error = {
        dateDue: null,
        customer: null,
        phone: null,
        email: null,
        items: [],
    };

 

    // Validate items
    invoiceData?.items?.forEach((item, index) => {
        let itemErrors = { name: null, quantity: null, price: null };

        if (!item?.name?.trim()) {
            itemErrors.name = "Please enter valid item name!";
            isValid = false;
        }

        if (!item?.quantity || item?.quantity <= 0 || isNaN(item?.quantity)) {
            itemErrors.quantity = "Please enter valid quantity!";
            isValid = false;
        }

        if (!item?.price || item?.price <= 0 || isNaN(item?.price)) {
            itemErrors.price = "Please enter valid Price!";
            isValid = false;
        }

        Error.items[index] = itemErrors;
    });

    return { isValid: isValid, errors: Error };
};

export default SaleReturnDataValidation;
